import { Box } from "@mui/material";

import type { ConnectionUrl } from "./connection-url";
import type { FC } from "react";

export const UrlText: FC<{ connection: ConnectionUrl }> = ({ connection }) => (
  <Box component="span" sx={{ fontFamily: "monospace", wordBreak: "break-all" }}>
    {connection.prefix}
    <Box
      component="mark"
      sx={{ bgcolor: "warning.light", color: "text.primary", borderRadius: 0.5, px: 0.25 }}
    >
      {connection.workspace}
    </Box>
    {connection.suffix}
  </Box>
);
